import styled from "styled-components";
import { createShouldForwardPropBlockList, deepMerge, resolveCssVarToHex } from "@components/common/utils/helper";
import { type SkeletonProps } from "./skeleton";
import { getBorderRadius } from "./skeleton.styles.utils";

type WrapperProps = Pick<SkeletonProps, "rounded"> & { display: SkeletonProps["theme"]; hasChildren: boolean };

export const Wrapper = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["rounded", "display"]),
})<WrapperProps>(({ rounded, display, theme, hasChildren }) => ({
    position: "relative",
    overflow: "hidden",
    pointerEvents: "none",
    display: "inline-flex",
    verticalAlign: "top",
    ...deepMerge(getBorderRadius(rounded, theme)),
    "&:before": {
        content: '""',
        backgroundColor: display === "dark" ? theme.colors.gray[800] : theme.colors.gray[200],
        position: "absolute",
        inset: hasChildren ? "10% 0 10% 0" : 0,
        ...deepMerge(getBorderRadius(rounded, theme)),
    },
    "&:after": {
        content: '""',
        backgroundImage:
            display === "dark"
                ? `linear-gradient(90deg, ${resolveCssVarToHex("--color-gray-300")}00 0%, ${resolveCssVarToHex(
                      "--color-gray-300",
                  )}33 20%, ${resolveCssVarToHex("--color-gray-300")}80 60%, ${resolveCssVarToHex("--color-gray-300")}00 100%)`
                : `linear-gradient(90deg, ${resolveCssVarToHex("--color-gray-50")}00 0%, ${resolveCssVarToHex(
                      "--color-gray-50",
                  )}33 20%, ${resolveCssVarToHex("--color-gray-50")}80 60%, ${resolveCssVarToHex("--color-gray-50")}00 100%)`,
        position: "absolute",
        inset: hasChildren ? "10% 0 10% 0" : 0,
        transform: "translateX(-100%)",
        animation: theme.animation.shimmer,
    },
}));

export const Text = styled("div")(() => ({
    opacity: 0,
    display: "inline-flex",
    verticalAlign: "top",
}));
